import { render, staticRenderFns } from "./upload-excel.vue?vue&type=template&id=c2115706&"
import script from "./upload-excel.vue?vue&type=script&lang=js&"
export * from "./upload-excel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports